<ng-template cdk-portal>
    <div *ngIf="isVisible" (click)="isVisible = false"
        class="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40"></div>
    <div *ngIf="isVisible" class="w-full p-4">
        <div class="relative bg-white rounded p-4 max-h-full overflow-y-auto">
            <div class="flex items-center justify-between mb-2">
                <div class="text-2xl font-semibold">{{ title }}</div>
                <img (click)="isVisible = false" src="/assets/icons/close.svg" alt="" class="w-4 cursor-pointer" />
            </div>
            <ng-content></ng-content>
        </div>
    </div>
</ng-template>
